import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountdownPipe } from './countdown.pipe';
import { MaskEmailPipe } from './mask-email.pipe';

@NgModule({
  declarations: [CountdownPipe, MaskEmailPipe],
  imports: [CommonModule],
  exports: [CountdownPipe, MaskEmailPipe]
})
export class CountdownPipeModule { }
